
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/reseller",
      function () {
        return require("private-next-pages/info/reseller/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/reseller"])
      });
    }
  